import { SupportedLang } from '@app/core/i18n/supported-langs';

export interface BrandingColors {
  header: string;
  primary: string;
  primaryDark: string;
  primaryLight: string;
  green: string;
}

export interface BrandingFooter {
  tagline?: string;
  showLinks: boolean;
}

export interface BrandingConfig {
  companyName: string;
  logoUrl: string;
  logoUrls?: Partial<Record<SupportedLang, string>>;
  logoAlt: string;
  colors: BrandingColors;
  footer: BrandingFooter;
}

export type PartialBrandingConfig = {
  companyName?: string;
  logoUrl?: string;
  logoUrls?: Partial<Record<SupportedLang, string>>;
  logoAlt?: string;
  colors?: Partial<BrandingColors>;
  footer?: Partial<BrandingFooter>;
};

export const DEFAULT_BRANDING: BrandingConfig = {
  companyName: '',
  logoUrl: '/images/Aena_logo_en.svg',
  logoUrls: {
    en: '/images/Aena_logo_en.svg',
    es: '/images/Aena_logo_es.svg',
  },
  logoAlt: '',
  colors: {
    header: '#1A2732',
    primary: '#1A2732',
    primaryDark: '#1A2732',
    primaryLight: '#EBF3FF',
    green: '#96CE00',
  },
  footer: {
    showLinks: true,
  },
};
